"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const field_group_1 = __importDefault(require("./field-group"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const fieldTypes_1 = require("../../../form/fieldTypes");
const styles_1 = require("../../../styles");
function ArrayInputRow({ path }) {
    const [{ config }, actions] = (0, use_form_1.default)(path, {
        eventProcessor: (value) => value
    });
    const { isReadOnly, addText, label, isRequired, emptyMsg } = config;
    const addValue = () => {
        config.addItem();
        // get the latest config since config.addItem()
        // above likely changed it
        const updatedConfig = config.getConfig();
        // if { [path]: [] } was added to updatedFields because
        // user deleted all fields, remove it since they are now
        // adding one
        actions.removePaths([path]);
        actions.setFormState({
            initialValue: config.getInitialValue(),
            config: updatedConfig
        });
    };
    const removeValue = (subFieldsIndex) => (valueIndex) => {
        const { removedPaths, isEmpty } = config.removeItem({
            subFieldsIndex,
            valueIndex
        });
        // get the latest config since config.removeItem()
        // above likely changed it
        const updatedConfig = config.getConfig();
        actions.removePaths(removedPaths);
        // set the value to [] since the user
        // has deleted all fields
        if (isEmpty) {
            actions.onChange([]);
        }
        actions.setFormState({
            initialValue: config.getInitialValue(),
            config: updatedConfig,
            updatedFieldKeysToRemove: removedPaths
        });
    };
    const isRemovable = (index) => !isReadOnly && (index === 0 ? !isRequired : true);
    const addRowText = addText || (label ? `+ Add ${label}` : `+ Add`);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement(styles_1.TextRowSpaceBetween, null,
            react_1.default.createElement(styles_1.UppercaseHeading, null, label))),
        react_1.default.createElement("div", null, config.subFields.length
            ? config.subFields.map((fields, index) => (react_1.default.createElement(field_group_1.default, { fields: fields, fieldTypes: fieldTypes_1.fieldTypes, onRemove: removeValue(index), valueIndex: fields[0].index, enableRemove: isRemovable(index), label: label ? `${label} ${index + 1}` : index + 1, key: `field-list-item-${path}-${index}` })))
            : emptyMsg && react_1.default.createElement(styles_1.EmptyStateParagraph, null, emptyMsg)),
        !isReadOnly && (react_1.default.createElement(styles_1.TextRowSpaceBottom, null,
            react_1.default.createElement(styles_1.TextButton, { type: "button", onClick: addValue }, addRowText)))));
}
ArrayInputRow.propTypes = {
    fieldTypes: prop_types_1.default.objectOf(prop_types_1.default.element).isRequired,
    path: prop_types_1.default.string.isRequired
};
exports.default = ArrayInputRow;
//# sourceMappingURL=container.js.map